import styled from "@emotion/styled";
import { units } from "../../../../types/units";

export const HostContainer = styled.div`
  display: inline-block;
  font-size: 0.9rem;
  ${units({
    color: "grey",
  })};
`;
